import { Show } from "solid-js";
import { styles } from "../styles";
import { QrCarousel, type QrDisplayItem } from "./QrList";

export type QrModalTarget = {
  title: string;
  items: QrDisplayItem[];
  onUpdate?: () => void;
};

export function QrModal(props: { target: QrModalTarget | null; cycleIntervalMs?: number; onClose: () => void }) {
  return (
    <Show when={props.target}>
      {(target) => (
        <div class={styles.qrPreviewLayer} role="presentation">
          <button class={styles.previewBackdrop} type="button" aria-label="QR表示を閉じる" onClick={props.onClose} />
          <section class={styles.listQrModal} role="dialog" aria-modal="true" aria-label={`${target().title} QR表示`}>
            <header class={styles.previewHeader}>
              <h2>{target().title}</h2>
              <button class={styles.iconButton} type="button" aria-label="閉じる" onClick={props.onClose}>✕</button>
            </header>
            <QrCarousel
              items={target().items}
              cycleIntervalMs={props.cycleIntervalMs}
              class={target().onUpdate ? styles.qrModalContentWithUpdate : undefined}
            />
            <Show when={target().onUpdate}>
              <button
                class={styles.qrModalUpdateButton}
                type="button"
                onClick={() => {
                  const update = target().onUpdate;
                  update?.();
                }}
              >{target().items.some((item) => item.qr) ? "QR更新" : "QR登録"}</button>
            </Show>
          </section>
        </div>
      )}
    </Show>
  );
}
